import { render, staticRenderFns } from "./select-file.vue?vue&type=template&id=6023eda3&scoped=true&"
import script from "./select-file.vue?vue&type=script&lang=js&"
export * from "./select-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023eda3",
  null
  
)

export default component.exports